import "whatwg-fetch";
import React from "react";
import Header from "../../header";
import "react-select/dist/react-select.css";
import { SkyLightStateless } from "react-skylight";
import { styles } from "../../menu/styles";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import * as RequisitionTypes from "../../../general/paper-state";
import UserApprovalsTable from "./approveUsers/user-approvals-table";
import ArticlesTable from "./articles/articleTable";
import { CircularProgress, TextField } from "material-ui";
import { connect } from "react-redux";
import * as validator from "../../../general/validators/validator";
import * as RequisitionActions from "../../../services/paper-service";
import * as ErrorAction from "../../../redux/action/error-action";
import * as TimeUtils from "../../../general/time-utils";
import * as UserActionTracker from "../../../services/tracker/user-action-tracker";

class PaperEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      showApprovingProgress: false,
      approvals: [],
      articles: [],
      deletedArticlesIds: [],
      motivation: "",
      canUserApprove: false,
      state: null,
      error: {
        motivation: "",
        allQuantitiesZero: ""
      },
      shouldRefresh: false
    };
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false
    });
    this.props.hideError();
    this.props.onCancel(this.state.shouldRefresh);
  };

  componentWillUnmount() {
    this.props.hideError();
  }

  componentDidMount() {
    this.setState({
      articles: this.props.data.articles || [],
      approvals: this.props.data.approvals,
      modalIsOpen: true,
      motivation: this.props.data.motivation,
      canUserApprove: this.props.data.canUserApprove,
      state: this.props.data.state
    });
  }

  onMotivationChange = e => {
    this.setState({
      motivation: e.target.value
    });
  };

  onApprove = (paper, orderNumber) => {
    if (!this.state.articles || this.state.articles.length === 0) {
      this.props.showError("Nu puteti aproba un referat fara articole!");
      return;
    }
    let articles = this.state.articles;
    let numberOfZeroQuantity = 0;

    for (let e in articles) {
      if (
        validator.isEmpty(articles[e].quantity) ||
        articles[e].quantity === 0 ||
        articles[e].quantity === "0" ||
        articles[e].quantity < 0
      ) {
        numberOfZeroQuantity++;
      }

      if (!articles[e].error) {
        articles[e].error = {};
      }

      var noArticolBugetar = false;
      if(this.props.canSetArticolBugetar && this.state.canUserApprove && validator.isEmpty(articles[e].articolBugetar)) {
        articles[e].error.articolBugetar = "Articolul bugetar lipseste";
        noArticolBugetar = true
      } else {
        articles[e].error.articolBugetar = null;
      }
      this.setState({articles})

      if(noArticolBugetar) {
        return;
      }
    }
    if (numberOfZeroQuantity === articles.length) {
      const error = this.state.error;
      error.allQuantitiesZero = "E nevoie de cel putin un produs! ";
      this.setState({ error });
      return;
    }

    this.approve(paper, true, orderNumber);
  };

  onReject = (paper, orderNumber) => {
    if (validator.isEmpty(this.state.motivation)) {
      this.setState({
        error: {
          motivation: "Lipseste motivarea respingerii"
        }
      });
      return;
    }
    this.approve(paper, false, orderNumber);
  };

  approve = (paper, approve, orderNumber) => {
    this.setState({
      showApprovingProgress: true
    });
    RequisitionActions.approve(
      paper.id,
      approve,
      this.state.motivation,
      this.state.deletedArticlesIds,
      this.state.articles
    )
      .then(t => {
        let newApprovals = this.state.approvals;
        newApprovals.push({
          orderNumber: orderNumber,
          approved: approve,
          approvedBy: {
            id: parseInt(this.props.userId),
            firstName: this.props.userFirstName,
            lastName: this.props.userLastName,
            email: this.props.userEmail,
            date: new Date().toLocaleTimeString()
          },
          firstName: this.props.userFirstName,
          lastName: this.props.userLastName,
          email: this.props.userEmail
        });
        this.setState({
          approvals: newApprovals,
          canUserApprove: false,
          showApprovingProgress: false,
          state: !approve ? RequisitionTypes.REJECTED : this.state.state,
          shouldRefresh: true
        });
        paper.canUserApprove = false;
        this.props.onApproveFinished(paper);
        this.props.hideError();
        UserActionTracker.trackPaperApproval(approve, paper.id);
      })
      .catch(err => {
        this.props.showError("Aprobarea a esuat! Va rog reincercati!");
        this.setState({
          showApprovingProgress: false
        });
      });
  };

  onPricePerUnitChanged = (e, index) => {
    let newPrice = e.target.value;
    let article = this.state.articles[index];
    article.pricePerUnit = newPrice;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onQuantityChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.quantity = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onArticolBugetarChange = (e, index) => {
    let newValue = e.target.value;
    let article = this.state.articles[index];
    article.articolBugetar = newValue;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onVatChanged = (e, index) => {
    let newQuantity = e.target.value;
    let article = this.state.articles[index];
    article.vat = newQuantity;
    let newArticles = this.state.articles;
    newArticles[index] = article;
    this.setState({
      articles: newArticles
    });
  };

  onDeleteClicked = (index, article) => {
    let newArticles = this.state.articles;
    newArticles.splice(index, 1);
    this.setState({
      articles: newArticles,
      deletedArticlesIds: this.state.deletedArticlesIds.concat([article.id])
    });
  };

  render() {
    let totalPriceNoVat = 0;
    let totalPriceWithVat = 0;
    this.state.articles.forEach(e => {
      let priceAllNoVat = e.quantity * e.pricePerUnit;
      totalPriceWithVat += (priceAllNoVat * e.vat) / 100 + priceAllNoVat;
      totalPriceNoVat += e.quantity * e.pricePerUnit;
    });

    totalPriceNoVat = Math.round(totalPriceNoVat * 100) / 100;
    totalPriceWithVat = Math.round(totalPriceWithVat * 100) / 100;

    return (
      <div>
        <RedirectIfNotLogged />

        <SkyLightStateless
          isVisible={this.state.modalIsOpen}
          dialogStyles={styles.defaultDialogStyles}
          onCloseClicked={this.closeModal}
          onOverlayClicked={this.closeModal}
          title={<Header title={this.props.title} />}
        >
          <div id={"parent"} style={{ display: "block", overflow: "auto" }}>
            <div>
              <div
                style={{ width: "100%", display: "flex", textAlign: "left" }}
              >
                <div style={{ margin: "0 auto" }}>
                  <div>
                    <strong>Cod: </strong>
                    <span>
                      {this.props.data.yearId +
                        "/" +
                        this.props.data.createdYear}
                    </span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Compartiment: </strong>
                    <span>{this.props.data.department.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Data crearii: </strong>
                    <span>
                      {TimeUtils.getSimpleFormat(this.props.data.createdDate)}
                    </span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <div
                      style={{
                        float: "left"
                      }}
                    >
                      <strong>Justificarea achizitiei: </strong>
                    </div>
                    <div
                      style={{
                        marginLeft: "10px",
                        float: "left",
                        maxWidth: "200px",
                        wordWrap: "break-word",
                        textAlign: "left"
                      }}
                    >
                      {" " + this.props.data.justification}
                    </div>
                  </div>
                  {this.props.canDownload && (
                    <div style={{ marginTop: "5px" }}>
                      <strong>Descarca: </strong>
                      {/* 
                      <span
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          textDecoration: "underline",
                          marginLeft: "10px"
                        }}
                        onClick={() =>
                          this.props.onFileDownloadClick(this.props.data, false)
                        }
                      >
                        DOCX
                      </span> */}

                      <span
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          textDecoration: "underline",
                          marginLeft: "10px"
                        }}
                        onClick={() => this.props.onClickPrint(this.props.data)}
                      >
                        PRINT
                      </span>

                      {this.props.downloadingDoc && (
                        <CircularProgress
                          size={15}
                          style={{ marginLeft: "10px" }}
                        />
                      )}
                    </div>
                  )}
                </div>

                <div style={{ margin: "0 auto" }}>
                  <div>
                    <strong>Categorie achizitie: </strong>
                    <span>{this.props.data.acquisitionCategory.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Sursa de finanatare: </strong>
                    <span>{this.props.data.financeSource.name}</span>
                  </div>
                  <div style={{ marginTop: "5px" }}>
                    <strong>Stare: </strong>
                    <span>
                      {RequisitionTypes.getTypeForId(this.state.state)}
                    </span>
                  </div>

                  <div style={{ marginTop: "5px" }}>
                    <strong>Creat de: </strong>
                    <span>
                      {this.props.data.createdBy.firstName +
                        " " +
                        this.props.data.createdBy.lastName}
                    </span>
                  </div>

                  <div style={{ marginTop: "5px" }}>
                    {RequisitionTypes.isRejected(this.state.state) ||
                    this.state.canUserApprove ? (
                      <div
                        style={{
                          float: "left"
                        }}
                      >
                        <strong>Motivatie/rezolutie: </strong>
                      </div>
                    ) : null}
                    {this.state.canUserApprove ? (
                      <TextField
                        hintText={"Motivati respingerea"}
                        value={this.state.motivation}
                        errorText={this.state.error.motivation}
                        onChange={this.onMotivationChange}
                      />
                    ) : (
                      <div
                        style={{
                          marginLeft: "10px",
                          float: "left",
                          maxWidth: "200px",
                          wordWrap: "break-word",
                          textAlign: "left"
                        }}
                      >
                        {this.state.motivation}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {
              <ArticlesTable
                articles={this.state.articles}
                yearId={this.props.data.yearId}
                createdYear={this.props.data.createdYear}
                canEdit={true}
                canEditPapers={this.props.canEditPapers}
                canSetArticolBugetar={this.props.canSetArticolBugetar}
                canUserApprove={this.state.canUserApprove}
                onVatChanged={this.onVatChanged}
                onQuantityChanged={this.onQuantityChanged}
                onArticolBugetarChange={this.onArticolBugetarChange}
                onPricePerUnitChanged={this.onPricePerUnitChanged}
                onDeleteClicked={this.onDeleteClicked}
                onEditClicked={this.onEditClicked}
                onFileDownloadClick={this.onFileDownloadClick}
              />
            }

            {this.state.error.allQuantitiesZero && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: 20
                }}
              >
                <strong style={{ color: "red" }}>
                  {this.state.error.allQuantitiesZero}
                </strong>
              </div>
            )}

            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ margin: "0 auto" }}>
                {totalPriceNoVat > 0 && <strong>Pret total fara TVA</strong>}
              </div>

              <div style={{ margin: "0 auto" }}>
                {totalPriceWithVat > 0 && <strong>Pret total cu TVA</strong>}
              </div>
            </div>

            <div style={{ width: "100%", display: "flex" }}>
              <div style={{ margin: "0 auto" }}>
                {totalPriceNoVat > 0 && <span>{totalPriceNoVat} RON</span>}
              </div>

              <div style={{ margin: "0 auto" }}>
                {totalPriceWithVat > 0 && <span>{totalPriceWithVat} RON</span>}
              </div>
            </div>

            <div style={{ marginTop: "30px" }}>
              <strong>Utilizatori care trebuie sa aprobe referatul</strong>
            </div>

            <div>
              <UserApprovalsTable
                paper={this.props.data}
                paperId={this.props.data.id}
                canApprove={this.state.canUserApprove}
                steps={this.props.data.flow.steps}
                approvals={this.state.approvals}
                showApprovingProgress={this.state.showApprovingProgress}
                state={this.state.state}
                onApprove={this.onApprove}
                onReject={this.onReject}
              />
            </div>
          </div>
        </SkyLightStateless>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userId: state.login.user.id,
    userEmail: state.login.user.email,
    userFirstName: state.login.user.firstName,
    userLastName: state.login.user.lastName,
    canEditPapers: state.login.user.canEditPapers,
    canSetArticolBugetar: state.login.user.canSetArticolBugetar,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaperEditModal);
